import { TimeZoneDetails } from '@tableau/self-service-schedules';
import { SiteUrls } from '@tableau/shared-urls';

import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { getAppStore } from '~src/app/AppStore';
import { PublishedConnectionExtractRefreshLevel } from '~src/publishedConnection/types/PublishedConnectionExtractRefreshLevel';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export function getPublishedConnectionExtractRefreshLevel(extractTransactionLevel?: string): PublishedConnectionExtractRefreshLevel {
  if (extractTransactionLevel && extractTransactionLevel.toLocaleLowerCase() === 'table') {
    return PublishedConnectionExtractRefreshLevel.Table;
  }
  return PublishedConnectionExtractRefreshLevel.Database;
}

export function isExtractSSSEnabled(): boolean {
  const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
  const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
  return isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;
}

export function getUserTimeZoneDetails(): TimeZoneDetails {
  const server = getSessionManagementServiceInstance();
  const userAccountSettingsLink = new SiteUrls({
    siteUrlName: server.sessionSiteUrlName(),
    queryString: window.location.search
  }).userSettingsUrl(server.sessionUserInfo().username, server.sessionUserInfo().domainName);
  return {
    timeZonesEnabled: true,
    timeZoneDisplayName: server.userTimeZone().displayName,
    linkToUserSettings: userAccountSettingsLink,
  };
}
